module.exports = __webpack_public_path__ + "static/media/electric-guitar.c3b0d359.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LessonsPage/assets/electric-guitar.png
// module id = 513
// module chunks = 0